import { ComoData } from "../views/ComoData/ComoData";
import { ComoDataTanks } from "../views/ComoDataTanks/ComoDataTanks";
import { IotDevicesView } from "views/IotDevices/IotDevicesView";
import { IotDeviceDetail } from "views/IotDevices/IotDeviceDetail";
import { iotDevicesTypes } from "redux/reducers/iotDevices/iotDevicesTypes";
import { PERMISSIONS } from "router/permissions";
import PropaneTankIcon from "@mui/icons-material/PropaneTank";

const { IOT_DEVICES } = PERMISSIONS;

const iotDevicesConfig = {
  reducer: "iotDevices",
  restoreKey: iotDevicesTypes.RESTORE_INITIAL,
};

export const comoDataRoutes = [
  {
    collapse: true,
    name: "Comodatos",
    icon: PropaneTankIcon,
    state: "commodatosCollapse",
    inSidebar: true,
    isProtected: true,
    rule: "COMMODATOS",
    views: [
      {
        path: "/comodatos",
        name: "ComoDatos",
        mini: "CD",
        component: ComoData,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "COMMODATOS",
      },
      {
        path: "/tanques_comodatos",
        name: "Tanques ComoDatos",
        mini: "TC",
        component: ComoDataTanks,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "COMMODATOS-TANK",
      },
      {
        path: "/iot-devices",
        name: "Dispositivos IoT",
        mini: "IOT",
        component: IotDevicesView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: IOT_DEVICES,
        ...iotDevicesConfig,
      },
      {
        path: "/iot-device/:id",
        name: "Detalle IoT",
        mini: "IOT",
        component: IotDeviceDetail,
        layout: "/admin",
        inSidebar: false,
        isProtected: true,
        rule: IOT_DEVICES,
        ...iotDevicesConfig,
      },
    ],
  },
];
